import RootRoute from './RootRoute';

export default RootRoute;